import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { toast } from "sonner";
import attendanceApis from "../../api/attendanceApis";
import { useBranchCode } from "../../util/hooks/useBranch";

interface Props {
  onClose?: () => void;
  onSuccess?: () => void;
}

function DownloadStaffAttendanceReport({ onClose, onSuccess}: Props) {
  const [academicYear, setAcademicYear] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const year = e.target.value;
    setAcademicYear(year);
  };

  const branchCode = useBranchCode()

  const handleDownload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!academicYear) {
      return toast.error("Please select an academic year");
    }

    setLoading(true);
    await attendanceApis.getStaffYearlyReport(branchCode, academicYear.split("-")[0],);
    setLoading(false);
    if (onSuccess) onSuccess();
    if (onClose) onClose();
  };

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 max-w-xl" onSubmit={handleDownload}>
        <h3 className="text-xl font-semibold text-neutral-400">
          Download Attendance Report - Academic Year Wise
        </h3>
        <CustomSelect
          name="academicYear"
          label="Academic Year"
           value={academicYear}
          options={["2026-27", "2027-28", "2028-29"]}
          placeholder="Select academic Year"
          onChange={handleInputChange}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            type="button"
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton 
            type="submit"
            color="bg-success-600" 
            text={loading ? "Downloading..." : "Download"} 
            disabled={loading}
          />
        </div>
      </form>
    </ModalLayout>
  );
}

export default DownloadStaffAttendanceReport;